import React, { useCallback, useEffect, useState } from 'react';
import * as DateFns from 'date-fns';
import { Link } from 'react-router-dom';

import { FUTURE, LIVE, PAST } from '../../../../config/constants';
import Badge from '../../Badge/Badge';
import { useInterval, useRouter } from '../../../../helpers/customHooks';
import { getTeamData, isCC, msToTime, selectedPracticeRoute } from '../../../../helpers';
import { colors } from '../../../../config/colors';
import { useUserState } from '../../../../store/hooks';
import { PracticeBadgePropsType } from './types';

const PracticeBadge = ({ practice, tooltipData, margin, liveBar }: PracticeBadgePropsType) => {
  
  const { pathname } = useRouter();
  const user = useUserState();
  const team = getTeamData(practice.homeTeamId, practice.league) || {
    teamAbbrName: 'CC',
    color: { text: '#FFFFFF', line: '#000000' }
  };
  
  const teamColor = team ? team.color.line : colors.black;
  // Elapsed Time
  const getElapsedTimeLive = useCallback(() => {
    const date = new Date();
    const now_utc = Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(),
      date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds(), date.getUTCMilliseconds());
    if (practice.startTime > now_utc) {
      return 0;
    }
    if (practice.currentDrillIndex < practice.drills.length) {
      if (!practice.drills[practice.currentDrillIndex].startTs) {
        return DateFns.getTime(now_utc) - practice.startTime;
      } else {
        return DateFns.getTime(now_utc) - practice.drills[0].startTs;
      }
    } else {
      return DateFns.getTime(now_utc) - practice.startTime;
    }
  }, [practice.currentDrillIndex, practice.drills, practice.startTime]);
  
  let elapsedLiveOrPastTime = 0;
  
  if (practice.live) {
    elapsedLiveOrPastTime = getElapsedTimeLive();
  }
  if (practice.status === PAST) {
    if (practice.drills && practice.drills.length > 0) {
      elapsedLiveOrPastTime = practice.drills[practice.drills.length - 1].endTs - practice.drills[0].startTs;
    } else {
      elapsedLiveOrPastTime = practice.endTime - practice.startTime;
    }
  }
  
  const [elapsedTime, setElapsedTime] = useState(elapsedLiveOrPastTime);
  const [live, setLive] = useState<number | null>(null);
  const delayTime = 1000;
  useInterval(() => setElapsedTime(getElapsedTimeLive()), live);
  useEffect(() => {
    if (practice.status === LIVE) {
      setTimeout(() => {
        setLive(delayTime);
      }, delayTime - elapsedTime % delayTime);
    }
  }, [practice.status]);
  useEffect(() => {
    if (practice.status === PAST) {
      setLive(null);
      if (practice.drills && practice.drills.length > 0) {
        setElapsedTime(practice.drills[practice.drills.length - 1].endTs - practice.drills[0].startTs);
      } else {
        setElapsedTime(practice.endTime - practice.startTime);
      }
    }
  }, [practice.status]);
  const isMobile = window.matchMedia("only screen and (max-width: 900px)").matches;
  // Elapsed Time
  return (
    <Link to={{ pathname: selectedPracticeRoute(pathname, practice, user, liveBar, isMobile), state: { toReturn: pathname } }}>
      <div
        className={'bd-02'}
        id={`practice-card-${practice.live ? 'live' : practice.status}-${practice.name}-${DateFns.format(new Date(practice.startTime), 'yyyy-MMMM-dd')}`}
      >
        <Badge
          past={DateFns.isPast(practice.startTime)}
          live={practice.live}
          tooltipData={tooltipData}
          margin={margin}
          style={isCC(user) ? { borderColor: `${teamColor}` } : {}}
        >
          <div className={'left left-live'} style={isCC(user) ? { paddingLeft: 0 } : {}}>
            {practice.live && (
              <img
                src="/assets/images/rec.svg"
                alt="live"
                width={isCC(user) ? `9px` : `12px`}
                className="led-img il-p oo-lp"
                style={isCC(user) ? { left: '-5px', top: '5px' } : {}}
              />
            )}
            {isCC(user) && (
              <img
                alt="team"
                src={'/assets/images/logos/' + (practice.league === 'nfl' ? team.teamAbbrName + '.svg' : team.teamAbbrName + '.png')}
                height="17"
                width="17"
                style={team.teamAbbrName === "TEN"? { marginTop: '-1px' }: { marginTop: '-3px' }}
              />
            )}
            {practice.name}
          </div>
          <div className={'right'}>
            {practice.status !== FUTURE && (
              <i className="mdi mdi-timer-outline" style={!practice.live ? { color: 'green' } : undefined} />
            )}
            {practice.live ?
              msToTime(elapsedTime) :
              practice.status !== FUTURE ?
                msToTime(elapsedTime) :
                DateFns.format(new Date(practice.startTime), 'hh:mm a')
            }
          </div>
        </Badge>
      </div>
    </Link>
  );
};

export default PracticeBadge;
